require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./push-the-configuration-to-geo-avalanche.json") })
        }
      }, "path---push-the-configuration-to-geo-avalanche");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---push-the-configuration-to-geo-avalanche!./.cache/json/push-the-configuration-to-geo-avalanche.json
// module id = 380
// module chunks = 231608221292675